import { useEffect, useState } from 'react'

import { ProductIds } from 'core'
import getBenefitDetails, {
  BenefitDetails as BenefitDetailsDto,
} from 'core/application/csiDashboard/csiSearch/getBenefitDetails'
import getProgramDetails, { ProgramDetailsDto } from 'core/application/csiDashboard/csiSearch/getProgramDetails'

import { queryRequest } from 'common/RequestUtils'
import { Col, Row, Skeleton } from 'common/components'

import GeneralDetails from '../../common/programDetails/GeneralDetails'
import BenefitDetails from './benefitDetails'

interface ProgramDetailsProps {
  translate: (key: string) => string
  companyId: string
  planPeriodId: string
  productId: ProductIds
}

const ProgramDetails = ({ translate, companyId, planPeriodId, productId }: ProgramDetailsProps) => {
  const [programDetails, setProgramDetails] = useState<ProgramDetailsDto | null>(null)
  const [loadingProgramDetails, setLoadingProgramDetails] = useState<boolean>(false)

  const [benefitDetails, setBenefitDetails] = useState<BenefitDetailsDto | null>(null)
  const [loadingbenefitDetails, setLoadingbenefitDetails] = useState<boolean>(false)

  useEffect(() => {
    fetchProgramDetails()
    fetchBenefitDetails()
  }, [planPeriodId])

  const fetchProgramDetails = async () => {
    setLoadingProgramDetails(true)
    const result = await queryRequest(() => getProgramDetails(companyId ?? '', planPeriodId))
    setProgramDetails(result)
    setLoadingProgramDetails(false)
  }

  const fetchBenefitDetails = async () => {
    setLoadingbenefitDetails(true)
    const result = await queryRequest(() => getBenefitDetails(planPeriodId))
    setBenefitDetails(result)
    setLoadingbenefitDetails(false)
  }

  return (
    <>
      <Row>
        <Col md={24}>
          <Skeleton loading={loadingProgramDetails}>
            {programDetails && <GeneralDetails translate={translate} generalDetails={programDetails} />}
          </Skeleton>
        </Col>
      </Row>
      <Row>
        <Col md={24} className="mt-32">
          <Skeleton loading={loadingbenefitDetails}>
            {benefitDetails && (
              <BenefitDetails
                translate={translate}
                benefitDetails={benefitDetails}
                refreshBenefitDetails={fetchBenefitDetails}
                productId={productId}
              />
            )}
          </Skeleton>
        </Col>
      </Row>
    </>
  )
}

export default ProgramDetails
